import { SITE } from "@/data/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="px-6 md:px-12 lg:px-16 py-12 md:py-16 border-t border-black/10"
    >
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-4">
          <p className="font-serif italic text-2xl md:text-3xl tracking-tight">
            Isabella Rubino
          </p>
          <p className="mt-3 text-[11px] uppercase tracking-[0.22em] text-neutral-500">
            Creative Director & Brand Storyteller
          </p>
        </div>
        <div className="col-span-6 md:col-span-4">
          <p className="text-[10px] uppercase tracking-[0.22em] text-neutral-500 mb-2">
            Contact
          </p>
          <a
            data-testid="footer-email"
            href={`mailto:${SITE.email}`}
            className="font-serif italic text-lg md:text-xl link-underline"
          >
            {SITE.email}
          </a>
          <div className="mt-6">
            <p className="text-[10px] uppercase tracking-[0.22em] text-neutral-500 mb-2">
              Elsewhere
            </p>
            <a
              data-testid="footer-vgo-link"
              href="https://www.vgo-associates.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-serif italic text-lg md:text-xl link-underline"
            >
              VGO Associates ↗
            </a>
          </div>
        </div>
        <div className="col-span-6 md:col-span-4 md:text-right">
          <p className="text-[10px] uppercase tracking-[0.22em] text-neutral-500 mb-2">
            ©  {year}
          </p>
          <p className="font-serif text-lg md:text-xl">
            All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
